import { Control, useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import OpeningHoursEditor from '@/shared/components/OpeningHoursEditor/OpeningHoursEditor'

interface OpeningHoursFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  name: string
}

/**
 * The week's opening hours as a field of a DynamicForm, which has no type for
 * a week: rendered by a `custom` field, it keeps the hours in the form like
 * any other value, so they are part of its Save and unsaved changes.
 */
function OpeningHoursField({ control, name }: OpeningHoursFieldProps) {
  const { i18n } = useTranslation()
  const { field } = useController({ name, control })

  return (
    <OpeningHoursEditor
      hours={field.value}
      onChange={field.onChange}
      language={i18n.language}
    />
  )
}

export default OpeningHoursField
